// Product analytics for route cards. The same three events, with the same
// property names, are sent by the iOS and Android apps.

export const ROUTE_CARD_CREATED = 'route_card_created';
export const ROUTE_CARD_PDF_EXPORTED = 'route_card_pdf_exported';
export const ROUTE_CARD_PAYWALL_SHOWN = 'route_card_paywall_shown';

export type RouteCardSurface = 'web_editor' | 'web_shared';

export interface RouteCardEventContext {
  hikeDayId: string;
  legCount: number;
  surface: RouteCardSurface;
}

export function routeCardEventProps({ hikeDayId, legCount, surface }: RouteCardEventContext) {
  return { hike_day_id: hikeDayId, leg_count: legCount, platform: 'web', surface };
}

/** Fire-and-forget; a missing analytics shim must never break the editor. */
export function trackRouteCard(event: string, context: RouteCardEventContext): void {
  try {
    window.mixpanel?.track(event, routeCardEventProps(context));
  } catch {
    // analytics is best-effort
  }
}
